export interface MarginCalculatorDetailModel {
    id: number;
    hospitalId: number;
    originalHospitalId?: number;
    isRate: boolean;
    state: string;
    isBillOverTime: boolean;
    billDorW: string;
    overTimeRate: number;
    shifts: number;
    hours: number;
    orientationHours: number;
    furniture: number;
    furnitureDelivery: number;
    utilities: number;
    relocation: number;
    licenseReimbursement: number;
    monthlyHousing: number;
    bonus: number;
    housingDeposit: number;
    meals: number;
    tittersPPD: number;
    extendedStayHotel: number;
    isCompBonus: boolean;
    weeks: number;
    isExtension: boolean;
    target: number;
    isBenefit: boolean;
    isMedical: boolean;
    age: number;
    medicalCoverage: string;
    medicalMonth: number;
    isDental: boolean;
    dentalCoverage: string;
    dentalMonth: number;
    stipendB: number;
    certReimb: number;
    rentalCar: number;
    shipping: number;
    giftCard: number;
    specialty: number;
    premiumRate: number;
    premiumBillRate: number;
    estTaxRate: number;
    shiftTime: number;
    oTMult: number;
    vmsFees: number;
    isAyaHousing: boolean;
    extDiscount: number;
    extDiscountType: boolean;
    discountPercent: number;
    andOr: string;
    billDorWM: string;
    dateFrom: Date;
    dateTo: Date;
    nIH: number;
    finger: number;
    hWares: number;
    altShift: number;
    shiftsAlt: number;
    hoursAlt: number;
    shiftTimeAlt: number;
    billRateAlt: number;
    overTimeRateAlt: number;
    shiftH: number;
    shiftM: number;
    shiftAltH: number;
    shiftAltM: number;
    shiftToH: number;
    shiftToM: number;
    shiftAltToH: number;
    shiftAltToM: number;
    isSubcontractor: boolean;
    reimOTSum: number;
    reimMSum: number;
    professionId: number;
    otPremiumMargin?: number;
}

export class MarginCalculatorDetail implements MarginCalculatorDetailModel {
    id: number;
    hospitalId: number;
    isRate: boolean;
    state: string;
    isBillOverTime: boolean;
    billDorW: string;
    overTimeRate: number;
    shifts: number;
    hours: number;
    orientationHours: number;
    furniture: number;
    furnitureDelivery: number;
    utilities: number;
    relocation: number;
    licenseReimbursement: number;
    monthlyHousing: number;
    bonus: number;
    housingDeposit: number;
    meals: number;
    tittersPPD: number;
    extendedStayHotel: number;
    isCompBonus: boolean;
    weeks: number;
    isExtension: boolean;
    target: number;
    isBenefit: boolean;
    isMedical: boolean;
    age: number;
    medicalCoverage: string;
    medicalMonth: number;
    isDental: boolean;
    dentalCoverage: string;
    dentalMonth: number;
    stipendB: number;
    certReimb: number;
    rentalCar: number;
    shipping: number;
    giftCard: number;
    specialty: number;
    premiumRate: number;
    premiumBillRate: number;
    estTaxRate: number;
    shiftTime: number;
    oTMult: number;
    vmsFees: number;
    isAyaHousing: boolean;
    extDiscount: number;
    extDiscountType: boolean;
    discountPercent: number;
    andOr: string;
    billDorWM: string;
    dateFrom: Date;
    dateTo: Date;
    nIH: number;
    finger: number;
    hWares: number;
    altShift: number;
    shiftsAlt: number;
    hoursAlt: number;
    shiftTimeAlt: number;
    billRateAlt: number;
    overTimeRateAlt: number;
    shiftH: number;
    shiftM: number;
    shiftAltH: number;
    shiftAltM: number;
    shiftToH: number;
    shiftToM: number;
    shiftAltToH: number;
    shiftAltToM: number;
    isSubcontractor: boolean;
    reimOTSum: number;
    reimMSum: number;
    professionId: number;
    otPremiumMargin?: number;
}
